import React from 'react';
import styled from 'styled-components';

interface ProfileInputProps {
  isEdit: boolean;
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  type?: string;
  inputId: string;
  inputName: string;
  inputAriaLabel: string;
  height?: string;
  width?: string;
}

const ProfileInput = ({
  isEdit,
  value,
  onChange,
  onBlur,
  type = 'text',
  inputId,
  inputName,
  inputAriaLabel,
  height = '40px',
  width = '100%',
}: ProfileInputProps) => {
  console.log('value', value);
  return (
    <Container>
      {!isEdit && <OriginData>{value}</OriginData>}
      {isEdit && (
        <Input
          readOnly={!isEdit}
          data-edit={isEdit}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          type={type}
          id={inputId}
          name={inputName}
          aria-label={inputAriaLabel}
          $height={height}
          $width={width}
        />
      )}
    </Container>
  );
};

export default ProfileInput;

const Container = styled.div`
  font-size: 20px;
  color: #000000;
  line-height: 140%;
  border: none;
  outline: none;
  flex: 1;
  display: flex;
  align-items: center;
`;

const OriginData = styled.div`
  font-size: 15px;
  line-height: 140%;
  color: #000000;
`;

interface InputProps {
  $height: string;
  $width: string;
}
const Input = styled.input<InputProps>`
  padding: 0 15px;
  border: 1px solid #b974ff;
  border-radius: 9px;
  &[data-edit='true'] {
    height: ${({ $height }) => $height};
    width: ${({ $width }) => $width};
    box-sizing: border-box;
  }
`;
